import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "relative min-h-screen flex items-center justify-center p-4"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-between px-6 py-5 border-b border-slate-200 shrink-0"
};
const _hoisted_3 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 shrink-0"
};
import { computed } from 'vue';
export default {
  __name: 'AppModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md'
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: [Number, String],
      default: 50
    },
    panelClass: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const SIZE_CLASSES = {
      sm: 'max-w-sm',
      md: 'max-w-md',
      lg: 'max-w-lg',
      xl: 'max-w-xl',
      '2xl': 'max-w-2xl',
      '3xl': 'max-w-3xl',
      '4xl': 'max-w-4xl',
      '5xl': 'max-w-5xl',
      '6xl': 'max-w-6xl'
    };
    const sizeClass = computed(() => props.size === 'none' ? '' : SIZE_CLASSES[props.size] || SIZE_CLASSES.md);
    function handleClose() {
      emit('close');
    }
    function handleOverlayClick() {
      if (props.closeOnOverlay) handleClose();
    }
    return (_ctx, _cache) => {
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return __props.visible ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 overflow-y-auto",
        style: _normalizeStyle({
          zIndex: __props.zIndex
        }),
        role: "dialog",
        "aria-modal": "true"
      }, [_createElementVNode("div", {
        class: "fixed inset-0 bg-black/50",
        onClick: handleOverlayClick
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["modal-panel relative bg-white rounded-2xl shadow-xl w-full overflow-hidden flex flex-col", [sizeClass.value, __props.scrollable ? 'max-h-[90vh]' : '', __props.panelClass]])
      }, [__props.title || _ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header", {}, () => [_createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1)]), __props.closable ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn-icon",
        title: "关闭",
        onClick: handleClose
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["flex min-h-0 flex-1 flex-col", __props.scrollable ? 'overflow-y-auto' : ''])
      }, [_renderSlot(_ctx.$slots, "default")], 2), _ctx.$slots.footer ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "footer")])) : _createCommentVNode("", true)], 2)])], 4)), [[_directive_modal_a11y, handleClose]]) : _createCommentVNode("", true);
    };
  }
};